import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_MONTH_FLOW,
  GET_DT_MONTH_FLOW_COLUMN,
  GET_DT_MONTH_FLOW_PLAN,
  SAVE_DT_MONTH_FLOW,
  SAVE_DT_MONTH_FLOW_COLUMN,
  SAVE_DT_MONTH_FLOW_PLAN,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import { getPermission } from "../../../../helpers/auth_helper";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function numberFormat(number, digit = 2) {
  if (number === null || number === "null" || number === "") return "";
  function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
  return parseFloat(number).toLocaleString(undefined, {
    minimumFractionDigits: digit,
  });
}


function MonthFlow(props) {
  const dispatch = useDispatch();
  const permission = getPermission();
  //   const [dateSelected, setDateSelected] = useState(props.dateSelected);
  const [dateNow, setDateNow] = useState(moment(new Date()).format("YYYY-MM"));
  const [AVGObject, setAVGObject] =useState({mode:"AVG"})
  const [showManageColumn, setShowManageColumn] = useState(false);
  const [columnDataList, setColumnDataList] = useState([]);
  const [columnManageList, setColumnManageList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [planList, setPlanList] = useState([]);
  const [planModelList, setPlanModelList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "Dummy",
      text: "Month",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
      },
      formatter: CountIndexRow,
    },
  ]);
  const [columnRenderPlanList, setColumnRenderPlanList] = useState([
    {
      dataField: "MONTHFLOW_MONTH",
      text: "Month",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: "#7E8EDA",
      },
      formatter: CountIndexRow,
    },
    // {
    //   dataField: "MONTHFLOWPLAN_DATA",
    //   text: "Flow/Fuel Plan",
    //   headerAlign: "center",
    //   editable: true,
    //   align: "center",
    //   headerStyle: {
    //     backgroundColor: "rgb(100 120 215)",
    //   },
    //   validator: (newValue, row, column, done) => {
    //     setTimeout(() => {
    //       if (isNaN(newValue)) {
    //         return done({
    //           valid: false,
    //           message: "Should be numeric",
    //         });
    //       }
    //       return done();
    //     }, 0);
    //     return {
    //       async: true,
    //     };
    //   },
    // },
  ]);
  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (
      rowIndex == modelDeviceList.length - 1 &&
      dateNow == moment(props.yearSelected).format("YYYY-MM")
    ) {
      style.fontWeight = "bold";
      style.color = "#FFFFFF";
      style.border = "3px solid #FFFFFF";
      // style.opacity = "0.6";
    } else {
      style.color = "white";
    }

    return style;
  };

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const addHeaderTable = () => {
    let prevHeader = document.getElementById(
      "monthflow-gas-volume-table-header"
    );
    prevHeader && prevHeader.remove();
    let thead = document
      .getElementById("monthflow-tab-table")
      .getElementsByTagName("thead")[0];
    let tr = document.createElement("tr");
    tr.innerHTML =
      '<th id="monthflow-gas-volume-table-header" colspan="' +
      (columnDataList.length + 1) +
      '" style="text-align:center;background-color:#556ee6;color:#FFFFFF">Month Flow</th>';
    thead.prepend(tr);
  };
  const getColumn = () => post(GET_DT_MONTH_FLOW_COLUMN, {});
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        MONTHFLOWCOLUMN_ORDER: columnManageList.length + 1,
        MONTHFLOWCOLUMN_NAME: "",
        SCADATAG_NAME: "",
        QTYPOINT_NAME: "",
        GMDRTAG_NAME: "",
        MONTHFLOWCOLUMN_DESC: "",
        MONTHFLOWCOLUMN_TYPE: "",
        MONTHFLOWCOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        color: colorOption[0],
        show: { label: "Show", value: 1 },
        source: { label: "Manual", value: 0 }
      },
    ]);
  };

  const formatNumber = (cellContent, row) => {
    return (
      <div>
        {numberFormat(cellContent, 2)}
      </div>
    );
  };

  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.MONTHFLOWCOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row =>
            row.MONTHFLOWCOLUMN_NAME == "" || row.MONTHFLOWCOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        let res = await post(SAVE_DT_MONTH_FLOW_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          setShowManageColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const generateRow = () => {
    function getDaysInMonth(year) {
      // console.log(year)
      let monthList = [];
      for (let index = 0; index < 12; index++) {
        let date = new Date(year, index, 1);
        // console.log(date)
        monthList.push({
          month: moment(date).format("M"),
          MONTHFLOW_DATE: moment(date).format("YYYY-MM-DD"),
          MONTHFLOW_MONTH: moment(date).format("M"),
          PID: "",
          MONTHFLOWPLAN_DATE: moment(date).format("YYYY-MM-DD"),
          MONTHFLOWPLAN_MONTH: moment(date).format("M"),
          // MONTHFLOWPLAN_DATA: 0,
          MONTHFLOWPLAN_EAST: 0,
          MONTHFLOWPLAN_WEST: 0,
          MONTHFLOWPLAN_TOTAL: 0,
        });
      }
      //   console.log(monthList)
      return monthList;
    }
    let dayList;

    dayList = getDaysInMonth(props.yearSelected);
    // console.log(dayList);
    dayList = addFieldToModelDeviceList(dayList);

    // console.log(dayList);
    setModelDeviceList(dayList);
  };
  const generatePlanRow = () => {
    function getDaysInMonth(year) {
      // console.log(year)
      let monthList = [];
      for (let index = 0; index < 12; index++) {
        let date = new Date(year, index, 1);
        // console.log(date)
        monthList.push({
          month: moment(date).format("M"),
          MONTHFLOW_DATE: moment(date).format("YYYY-MM-DD"),
          MONTHFLOW_MONTH: moment(date).format("M"),
        });
      }
      //   console.log(monthList)
      return monthList;
    }
    let planList = getDaysInMonth(props.yearSelected);
    planList = addFieldToPlanList(planList);
    setPlanModelList(planList);
  };
  const renderColumn = () => {
    setColumnRenderList([
      {
        dataField: "MONTHFLOW_MONTH",
        text: "Month",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: "#7E8EDA",
          width: "110px",
        },
        style:{width: "110px",},
        formatter: CountIndexRow,
      },
      {
        dataField: "MONTHFLOWPLAN_EAST",
        text: "Flow Plan East",
        headerAlign: "center",
        editable: true,
        align: "center",
        formatter: formatNumber,
        headerStyle: {
          backgroundColor: "rgb(100 120 215)",
          width: "115px",
        },
        style: { cursor: "pointer" ,width: "115px",},
        editorStyle: () => {
          return { height: "25px" }
        },
        validator: (newValue, row, column, done) => {
          setTimeout(() => {
            if (isNaN(newValue)) {
              return done({
                valid: false,
                message: "Should be numeric",
              });
            }
            return done();
          }, 0);
          return {
            async: true,
          };
        },
      },
      {
        dataField: "MONTHFLOWPLAN_WEST",
        text: "Flow Plan West",
        headerAlign: "center",
        editable: true,
        align: "center",
        formatter: formatNumber,
        headerStyle: {
          backgroundColor: "rgb(100 120 215)",
          width: "115px",
        },
        style: { cursor: "pointer", width: "115px",},
        editorStyle: () => {
          return { height: "25px" }
        },
        validator: (newValue, row, column, done) => {
          setTimeout(() => {
            if (isNaN(newValue)) {
              return done({
                valid: false,
                message: "Should be numeric",
              });
            }
            return done();
          }, 0);
          return {
            async: true,
          };
        },
      },
      {
        dataField: "MONTHFLOWPLAN_TOTAL",
        text: "Flow Plan Total",
        headerAlign: "center",
        editable: true,
        align: "center",
        formatter: formatNumber,
        headerStyle: {
          backgroundColor: "rgb(100 120 215)",
          width: "115px",
        },
        style: { cursor: "pointer" ,width: "115px",},
        editorStyle: () => {
          return { height: "25px" }
        },
        validator: (newValue, row, column, done) => {
          setTimeout(() => {
            if (isNaN(newValue)) {
              return done({
                valid: false,
                message: "Should be numeric",
              });
            }
            return done();
          }, 0);
          return {
            async: true,
          };
        },
      },
      {
        dataField: "",
        text: "",
        headerAlign: "center",
        editable: false,
        align: "center",
        isDummy: true,
        headerStyle: {
          width: "30px",
        },
        style:{
          width: "30px",
        },
        headerClasses: "hidden-column",
        classes: "hidden-column",
      },
      {
        dataField: "month",
        text: "Month",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          backgroundColor: colorOption[0].label,
          width: "5%",
        },
        style:{width:"5%"}
      },
      ...columnDataList
        .sort((a, b) =>
          a.MONTHFLOWCOLUMN_ORDER > b.MONTHFLOWCOLUMN_ORDER
            ? 1
            : b.MONTHFLOWCOLUMN_ORDER > a.MONTHFLOWCOLUMN_ORDER
              ? -1
              : 0
        )
        .filter(
          obj =>
            obj.MONTHFLOWCOLUMN_SHOW == true ||
            obj.MONTHFLOWCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.MONTHFLOWCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.MONTHFLOWCOLUMN_NAME,
          headerAlign: "center",
          editable: true,
          align: "center",
          formatter: formatNumber,
          editorStyle: () => {
            return { height: "25px" }
          },
          headerStyle: {
            backgroundColor: colorOption[obj.MONTHFLOWCOLUMN_TYPE].label,
            width: "5%",
          },
          style: {
            cursor: "pointer",
            width: "5%",
          },
          classes: (cell, row, rowIndex, colIndex) => {
            let className = ""
            if (obj.STATUS_FLAG != 0) className += 'from-source';
            if (obj.STATUS_FLAG == 1 || obj.STATUS_FLAG == 3) className += ' pmis';
            return className
          },
          validator: (newValue, row, column, done) => {
            setTimeout(() => {
              if (isNaN(newValue)) {
                return done({
                  valid: false,
                  message: "Should be numeric",
                });
              }
              return done();
            }, 0);
            return {
              async: true,
            };
          },
        })),
    ]);
  };
  const handleShowManageColumn = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtMonthFlowColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          color: colorOption[obj.MONTHFLOWCOLUMN_TYPE],
          show: obj.MONTHFLOWCOLUMN_SHOW == 1 ? { label: "Show", value: 1 } : { label: "Hide", value: 0 },
          source: obj.STATUS_FLAG == 0 ? { label: "Manual", value: 0 } : obj.STATUS_FLAG == 1 ? { label: "Scada", value: 1 } : { label: "Flow Selection", value: 2 }
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };
  const handleSaveData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      let data = [];
      let dataPlan = [];
      modelDeviceList.map(obj => {
        let {
          PID,
          MONTHFLOWPLAN_DATE,
          MONTHFLOWPLAN_MONTH,
          // MONTHFLOWPLAN_DATA,
          MONTHFLOWPLAN_EAST,
          MONTHFLOWPLAN_WEST,
          MONTHFLOWPLAN_TOTAL,
          PRIORITY_FLAG,
          STATUS_FLAG,
        } = obj;
        dataPlan.push({
          PID,
          MONTHFLOWPLAN_DATE,
          MONTHFLOWPLAN_MONTH,
          // MONTHFLOWPLAN_DATA,
          MONTHFLOWPLAN_EAST,
          MONTHFLOWPLAN_WEST,
          MONTHFLOWPLAN_TOTAL,
          PRIORITY_FLAG,
          STATUS_FLAG,
        });
        columnDataList.map(objColumn => {
          data.push({
            ...obj[
            `${objColumn.MONTHFLOWCOLUMN_NAME.replaceAll(".", "_")}__data`
            ],
            MONTHFLOWACTUAL_DATA:
              obj[objColumn.MONTHFLOWCOLUMN_NAME.replaceAll(".", "_")],
          });
        });
      });
      let [res1, res2] = await Promise.all([
        post(SAVE_DT_MONTH_FLOW, data),
        post(SAVE_DT_MONTH_FLOW_PLAN, dataPlan),
      ]);

      if (res1.resultCode != 200) {
        dispatch(messageAction.showMessage(res1.resultDescription));
      } else if (res2.resultCode != 200) {
        dispatch(messageAction.showMessage(res2.resultDescription));
      } else {
        dispatch(messageAction.showMessage("Save success."));
        fetchData();
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const fetchData = async () => {
    dispatch(loadingAction.showLoading());

    try {
      // generateRow();
      let column = await getColumn();
      setColumnDataList(
        column.data.dtMonthFlowColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let [res1, res2] = await Promise.all([
        post(GET_DT_MONTH_FLOW, {
          MONTHFLOW_YEAR: moment(new Date(props.yearSelected, 0, 1)).format(
            "YYYY-MM-DD"
          ),
        }),
        post(GET_DT_MONTH_FLOW_PLAN, {
          MONTHFLOWPLAN_YEAR: moment(new Date(props.yearSelected, 0, 1)).format(
            "YYYY-MM-DD"
          ),
        }),
      ]);
      // res2.data.dtMonthFlowPlanList
      setPlanList(res2.data.dtMonthFlowPlanList);
      setDataList(res1.data.dtMonthFlowList);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  useEffect(() => {
    generateRow();
    // generatePlanRow();
  }, [dataList]);
  useEffect(() => {
    fetchData();
  }, [props.yearSelected]);
  useEffect(() => {
    renderColumn();
    // addHeaderTable();
    if (columnDataList.length > 1) {
      generateRow();
      // generatePlanRow()
    }
  }, [columnDataList]);
  const calculateAVG = () => {
    let planAvgEast =
    modelDeviceList.reduce((a, b) => a + b.MONTHFLOWPLAN_EAST, 0) /
    modelDeviceList.length;
  let planAvgWest =
    modelDeviceList.reduce((a, b) => a + b.MONTHFLOWPLAN_WEST, 0) /
    modelDeviceList.length;
    let planAvgTotal =
    modelDeviceList.reduce((a, b) => a + b.MONTHFLOWPLAN_TOTAL, 0) /
    modelDeviceList.length;
  let avgObj = {mode:"AVG",month:"AVG",MONTHFLOWPLAN_EAST:planAvgEast,MONTHFLOWPLAN_WEST:planAvgWest,MONTHFLOWPLAN_TOTAL:planAvgTotal};
  columnDataList.map(collumn => {
    let sum = 0;
    modelDeviceList.map(object => {
      sum += object[collumn.MONTHFLOWCOLUMN_NAME];
    });
    avgObj[collumn.MONTHFLOWCOLUMN_NAME]=sum/modelDeviceList.length


  });
  setAVGObject(avgObj)
  };
  useEffect(() => {
    calculateAVG()
  }, [modelDeviceList]);
  const addFieldToModelDeviceList = rowList => {
    let dataModel = {
      PID: "",
      MONTHFLOW_DATE: "",
      MONTHFLOWCOLUMN_PID: "",
      MONTHFLOWCOLUMN_ORDER: 0,
      MONTHFLOWCOLUMN_NAME: "",
      MONTHFLOW_MONTH: 0,
      MONTHFLOWACTUAL_DATA: 0,
      SOURCE_PID: null,
      SOURCE_NAME: null,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };

    if (rowList.length > 0) {
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        // console.log(objColumn)

        modelList = rowList.map(obj => {
          let value = data.find(
            value =>
              value.MONTHFLOWCOLUMN_PID == objColumn.PID &&
              value.MONTHFLOW_MONTH == obj.MONTHFLOW_MONTH
          );
          let plan = planList.find(
            value => obj.MONTHFLOW_MONTH == value.MONTHFLOWPLAN_MONTH
          );
          obj[objColumn.MONTHFLOWCOLUMN_NAME.replaceAll(".", "_")] = value
            ? value.MONTHFLOWACTUAL_DATA
            : 0;
          obj[`${objColumn.MONTHFLOWCOLUMN_NAME.replaceAll(".", "_")}__data`] =
          {
            ...dataModel,
            ...value,
            MONTHFLOW_DATE: obj.MONTHFLOW_DATE,
            MONTHFLOW_MONTH: obj.MONTHFLOW_MONTH,
            MONTHFLOWCOLUMN_PID: objColumn.PID,
            MONTHFLOWCOLUMN_ORDER: objColumn.MONTHFLOWCOLUMN_ORDER,
            MONTHFLOWCOLUMN_NAME: objColumn.MONTHFLOWCOLUMN_NAME,
          };
          return { ...obj, month: obj.month, ...plan };
        });
      });
      // console.log(modelList)
      return modelList;
    }
  };
  const addFieldToPlanList = rowList => {
    // console.log(planList);
    let dataModel = {
      PID: "",
      MONTHFLOWPLAN_DATE: "",
      MONTHFLOWPLAN_MONTH: 0,
      // MONTHFLOWPLAN_DATA: 0,
      MONTHFLOWPLAN_EAST: 0,
      MONTHFLOWPLAN_WEST: 0,
      MONTHFLOWPLAN_TOTAL: 0,
    };
    if (rowList.length > 0) {
      let modelList = [];
      let data = planList;

      modelList = rowList.map(obj => {
        let value = data.find(
          value => value.MONTHFLOWPLAN_MONTH == obj.MONTHFLOW_MONTH
        );
        if (value) {
          dataModel.MONTHFLOWPLAN_EAST = value.MONTHFLOWPLAN_EAST;
          dataModel.MONTHFLOWPLAN_WEST = value.MONTHFLOWPLAN_WEST;
          dataModel.MONTHFLOWPLAN_TOTAL = value.MONTHFLOWPLAN_TOTAL;
        }
        return {
          ...dataModel,
          month: obj.month,
          MONTHFLOWPLAN_DATE: obj.MONTHFLOW_DATE,
          MONTHFLOWPLAN_MONTH: obj.MONTHFLOW_MONTH,
        };
      });
      return modelList;
    }
  };
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  MONTHFLOWCOLUMN_TYPE: selected.value
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  MONTHFLOWCOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const columnManage = [
    {
      dataField: "MONTHFLOWCOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "MONTHFLOWCOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    // {
    //   dataField: "STATUS_FLAG",
    //   text: "Source",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   editor: {
    //     type: Type.SELECT,
    //     options: [
    //       {
    //         value: 0,
    //         label: "Manual",
    //       },
    //       {
    //         value: 1,
    //         label: "SCADA",
    //       },
    //       {
    //         value: 2,
    //         label: "Flow Selection",
    //       },
    //       {
    //         value: 3,
    //         label: "GMDR",
    //       },
    //     ],
    //   },
    //   formatter: (cell, row, rowIndex) =>
    //     row.STATUS_FLAG == 0
    //       ? "Manual"
    //       : row.STATUS_FLAG == 1
    //       ? "SCADA"
    //       : row.STATUS_FLAG == 2
    //       ? "Flow Selection"
    //       : "GMDR",
    // },
    // {
    //   dataField: "SCADATAG_NAME",
    //   text: "SCADA Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },

    // {
    //   dataField: "QTYPOINT_NAME",
    //   text: "Quality Point",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    // {
    //   dataField: "GMDRTAG_NAME",
    //   text: "GMDR Tag",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "100px",
    //   },
    // },
    {
      dataField: "MONTHFLOWCOLUMN_DESC",
      text: "Description",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "150px",
        cursor:"pointer",
      },
    },
    {
      dataField: "color",
      text: "Color",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "70px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: PickColor,
    },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === 'asc') {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow
    },
    {
      dataField: "PRIORITY_FLAG",
      text: "Priority Report",
      headerAlign: "center",
      sort: false,
      editable: true,
      align: "center",
      style: {
        width: "60px",
        cursor:"pointer",
      },
      type: "number",
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <div>
      <Col sm="12">
        <div className="d-flex justify-content-end mt-2 ">

          {permission.mMIM && (
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => handleShowManageColumn()}
            >
              <i className="bx bx-columns"></i>&nbsp; Manage Column Flow/Fuel (
              Monthly )
            </button>
          )}

          {permission.eFFO && (
            <button
              type="button"
              className="btn btn-success me-2"
              onClick={handleSaveData}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
          )}

        </div>
        <div className="mt-2 row">
          {/* <div className="col">
            <BootstrapTable
              id="monthflowplan-tab-table"
              keyField="month"
              data={planModelList}
              columns={columnRenderPlanList}
              // rowStyle={rowStyle}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            />
          </div> */}

          <div className="col">
            <BootstrapTable
              id="monthflow-tab-table"
              keyField="month"
              data={modelDeviceList}
              columns={columnRenderList}
              rowStyle={rowStyle}
              // wrapperClasses={"hidden-column"}
              wrapperClasses={"hidden-column"}
              headerClasses="header-style"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                onStartEdit: (oldValue, newValue, row, column) => {
                  $("#monthflow-tab-table .form-control.editor.edit-text").bind(
                    "enterKey",
                    function (e) {
                      let cell = $(this).parent().next();
                      setTimeout(() => {
                        cell.click();
                      }, 50);
                    }
                  );
                  $(
                    "#monthflow-tab-table .form-control.editor.edit-text"
                  ).keypress(function (e) {
                    if (e.keyCode == 13) {
                      $(this).trigger("enterKey");
                    }
                  });
                },
                afterSaveCell: (oldValue, newValue, row, column) => {
                  // console.log(column);
                  calculateAVG()
                },
              })}
            />
              <BootstrapTable
            
            id="monthflow-tab-avg-table"
            keyField="mode"
            data={[AVGObject]}
            columns={[ {
              dataField: "mode",
              text: "Month",
              headerAlign: "center",
       
              align: "center",
        
              style:{
                width: "125px",
              }
            },
            {
              dataField: "MONTHFLOWPLAN_EAST",
              text: "Flow Plan East",
              headerAlign: "center",
         
              align: "center",
              formatter: formatNumber,
              style:{
                width: "115px",
              }
          
            },
            {
              dataField: "MONTHFLOWPLAN_WEST",
              text: "Flow Plan West",
              headerAlign: "center",
            
              align: "center",
              formatter: formatNumber,
              style:{
                width: "115px",
              }
              
            },
            {
              dataField: "MONTHFLOWPLAN_TOTAL",
              text: "Flow Plan Total",
              headerAlign: "center",
     
              align: "center",
              formatter: formatNumber,
          
              style:{
                width: "115px",
              }
           
            },...columnRenderList.filter((row,index)=>index>3)]}
            rowStyle={rowStyle}
            wrapperClasses={"hidden-column mt-4"}
            headerClasses="header-style hide"
            
          />
          </div>
        </div>
      </Col>
      <Modal size="xl" isOpen={showManageColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Monthly Flow/Fuel Oil</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-monthflow-table"
            keyField="ROW"
            wrapperClasses="table-on-scroll"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(column);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "MONTHFLOWCOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default MonthFlow;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn
const deleteColumnButton = (cell, row) => (
  <OverButton
    onClick={() => {
      // onDelete(row);
    }}
    color="danger"
    icon="fas fa-trash-alt"
    label="Delete"
  />
);


MonthFlow.propTypes = {
  yearSelected: PropTypes.any,
};
